import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import FileActivity from './components/FileActivity';
import RankedMembers from './components/RankedMembers';
import QAndAChart from 'router/subrouters/DataRoom/components/QAndAChart';
import TimeframeFilter from 'router/subrouters/DataRoom/components/TimeframeFilter';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { TIMEFRAME_COPY, TIMEFRAME_FILTER_OPTIONS } from './data';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { AnalyticsTimeframe } from '../Reports/types';

import './Overview.styles.scss';
import './Overview.styles.responsive.scss';

type OverviewProps = {
  className?: string;
};

const Overview: React.FC<OverviewProps> = (props) => {
  const { className } = props;

  const classes = classNames('overview', className);

  const {
    dataRoom: { _id },
    preferredAnalyticsTimeframe,
    setDataRoom,
  } = useContext(DataRoomContext);

  const handleChangeTimeframe = useCallback(
    (timeframe: string) => {
      const preferredAnalyticsTimeframe = timeframe as AnalyticsTimeframe;

      setDataRoom((old) => ({
        ...old,
        currentMember: {
          ...old.currentMember,
          preferredAnalyticsTimeframe,
        },
      }));

      dataRoomApi.room.updatePreferredValues(_id, {
        preferredAnalyticsTimeframe,
      });
    },
    [_id, setDataRoom],
  );

  return (
    <div className={classes}>
      <TimeframeFilter
        selectedTimeframe={preferredAnalyticsTimeframe}
        timeframeOptions={TIMEFRAME_FILTER_OPTIONS}
        timeframeOptionsCopy={TIMEFRAME_COPY}
        onChangeTimeframe={handleChangeTimeframe}
      />

      <div className="overview__wrapper">
        <RankedMembers className="overview__card-wrapper" />
        <FileActivity className="overview__card-wrapper" />
        <QAndAChart className="overview__card-wrapper" />
      </div>
    </div>
  );
};

export default Overview;
